import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Copy, Check, Mail, ShieldAlert, Headphones, Clock } from "lucide-react";
import { toast } from "sonner";
import { useHeaderStore } from "../../store/headerStore";
import "../../styles/help-center.css";

export default function HelpCenterContactPage() {
  const { setPageTitleOverride } = useHeaderStore();
  const [copiedEmail, setCopiedEmail] = useState<string | null>(null);

  useEffect(() => {
    setPageTitleOverride("CONTACT");
    return () => setPageTitleOverride(null);
  }, [setPageTitleOverride]);

  const copyToClipboard = (email: string) => {
    navigator.clipboard.writeText(email);
    setCopiedEmail(email);
    toast.success(`Copied ${email} to clipboard!`);
    setTimeout(() => {
      setCopiedEmail(null);
    }, 2000);
  };

  return (
    <div className="help-center-container">
      {/* Back button */}
      <Link to="/help-center" className="help-back-btn">
        <ArrowLeft size={16} />
        <span>Back</span>
      </Link>

      {/* Main Title */}
      <div className="help-page-header">
        <h1 className="help-page-title">Contact</h1>
      </div>

      {/* Contact Card matching Image 2 */}
      <div className="contact-main-card">
        <h2 className="contact-card-subheading">
          Get in touch with us in case you need any help
        </h2>

        {/* Primary Support Email */}
        <div className="contact-email-row">
          <a
            href="mailto:support@threatactix.com"
            className="contact-email-link"
          >
            support@threatactix.com
          </a>

          <button
            type="button"
            className={`contact-copy-btn ${
              copiedEmail === "support@threatactix.com" ? "is-copied" : ""
            }`}
            onClick={() => copyToClipboard("support@threatactix.com")}
            title="Copy email to clipboard"
            aria-label="Copy support email address"
          >
            {copiedEmail === "support@threatactix.com" ? (
              <>
                <Check size={14} />
                <span>Copied</span>
              </>
            ) : (
              <>
                <Copy size={14} />
                <span>Copy</span>
              </>
            )}
          </button>
        </div>

        {/* Support Channels Grid */}
        <div className="contact-support-channels">
          {/* SOC Emergency Incident Response */}
          <div className="contact-channel-card">
            <span className="contact-channel-title">
              <ShieldAlert size={16} style={{ color: "#ef4444" }} />
              24/7 SOC Incident Response
            </span>
            <p className="contact-channel-desc">
              For active data breach emergencies, high-severity ransomware threats, and urgent takedowns.
            </p>
            <a
              href="mailto:soc@threatactix.com"
              className="contact-channel-val"
            >
              soc@threatactix.com
            </a>
          </div>

          {/* Enterprise Support & Billing */}
          <div className="contact-channel-card">
            <span className="contact-channel-title">
              <Headphones size={16} style={{ color: "#818cf8" }} />
              Enterprise & Advisory
            </span>
            <p className="contact-channel-desc">
              For custom feeds, API integration assistance, dedicated analyst briefings, and billing inquiries.
            </p>
            <a
              href="mailto:advisory@threatactix.com"
              className="contact-channel-val"
            >
              advisory@threatactix.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
